module.exports = __webpack_public_path__ + "img/login-bg2.c3bd1d7c.jpg";